// extracted by mini-css-extract-plugin
export var mainImage = "hero-module--mainImage--ix9c0";
export var smallHero = "hero-module--smallHero--gCyEz";
export var heroInner = "hero-module--heroInner--Mafmr";
export var smallMainImage = "hero-module--smallMainImage--837c0";
export var hero = "hero-module--hero--kBW0m";
export var slideInner = "hero-module--slideInner--7RYYX";
export var subTitle = "hero-module--subTitle--koaAf";
export var title = "hero-module--title--2AwTV";
export var cta = "hero-module--cta--U86g- buttons--button--OMEYV buttons--darkButton--Js567";